import template from './svg.html';
import Vue from 'vue';


export const vfSvg = Vue.extend({
    template,
    data() {
        return {
            viewBox: '0 0 0 0',
            defs: '',
            graphics: '',
        };
    },
    computed: {
        getClasses() { return {}; },
        getTransform() { return ''; },
        getGraphics() {
            return this.graphics;
        },
        hasCircle: () => false,
    },
});
